module.exports={select:"Kijelölés",selected:"Kijelölt"};